import { Link, Outlet } from "react-router-dom";
import { useAppContext } from "@contexts/AppProvider";
import TranslatableText from "@components/translations/TranslatableText";
import HelpCenterNav from "./HelpCenterNav";

const HelpCenterBanner = ({ bucketUrl }: { bucketUrl: string }) => (
	<img
		src={`${bucketUrl}/project_select_banner.jpg`}
		alt="EX-ACT Help Centre"
		className="w-100"
		style={{ aspectRatio: "700 / 383", objectFit: "cover", objectPosition: "top" }}
	/>
);

const HelpCenter = () => {
	const bucketUrl = useAppContext();

	return (
		<div className="login-container help-center">
			<article className="bg-gray">
				<HelpCenterBanner bucketUrl={bucketUrl} />
				<div className="d-flex f-column pt-1 pb-2 px-2">
					<h1 className="help-center__banner-title module-header w-fit ff-medium-ext fs-18 mt-1 mb-1">
						<TranslatableText translationKey="help_center.title" />
					</h1>
					<p className="fs-13 ff-light mb-2">
						<TranslatableText translationKey="help_center.description" />
					</p>

					<HelpCenterNav />

					<Outlet />

					<p className="fs-12 ff-light mt-2">
						<TranslatableText translationKey="help_center.contact_hint" />
					</p>

					<Link to="/" className="fs-13 text-quat-de mt-1 align-self-start">
						<TranslatableText translationKey="help_center.back_to_projects" />
					</Link>
				</div>
			</article>
		</div>
	);
};

export default HelpCenter;
